import "../../FhText.css";
import { useSlots, computed, provide, onMounted, openBlock, createBlock, resolveDynamicComponent, normalizeClass, normalizeStyle, withCtx, renderSlot } from "vue";
import { BODY_TAGS, ALL_TAGS, BODY_VARIANTS, ALL_VARIANTS, ALIGNMENTS_ENUMS, DEFAULT_COLOR, FONT_WEIGHTS } from "./constants.mjs";
import { TEXT_COLORS } from "./colors.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhText",
  props: {
    tag: {
      type: String,
      default: BODY_TAGS.P,
      validator: (value) => Object.values(ALL_TAGS).includes(value)
    },
    variant: {
      type: String,
      default: BODY_VARIANTS.BODY_LG,
      validator: (value) => Object.values(ALL_VARIANTS).includes(value)
    },
    alignment: {
      type: String,
      default: ALIGNMENTS_ENUMS.START,
      validator: (value) => Object.values(ALIGNMENTS_ENUMS).includes(value)
    },
    color: {
      type: String,
      default: DEFAULT_COLOR,
      validator: (value) => TEXT_COLORS.includes(value)
    },
    weight: {
      type: String,
      default: FONT_WEIGHTS.REGULAR,
      validator: (value) => Object.values(FONT_WEIGHTS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const computedClasses = computed(() => {
      const fontWeight = props.variant.startsWith("display") ? FONT_WEIGHTS.MEDIUM : props.weight;
      return [
        "fh-text",
        `fh-text--${props.variant}`,
        `fh-text--${fontWeight}`,
        props.alignment !== ALIGNMENTS_ENUMS.START && `fh-text--${props.alignment}`
      ];
    });
    const computedColor = computed(() => {
      return [
        props.color && props.color !== "default" && `--text-color: var(--fh-color-text-${props.color});`
      ];
    });
    provide("textVariant", props.variant);
    onMounted(() => {
      if (!slots.default || slots.default().length === 0) {
        console.warn("FhText component requires text.");
      }
      if (props.tag === "span" && props.alignment !== "start") {
        console.warn(
          "FhText component set to display inline does not support text alignment"
        );
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(props.tag), {
        class: normalizeClass(computedClasses.value),
        style: normalizeStyle(computedColor.value)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["class", "style"]);
    };
  }
};
const FhText = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e7fe3031"]]);
export {
  FhText as default
};
//# sourceMappingURL=FhText.mjs.map
